import VLabel from './VLabel'

/* istanbul ignore next */
VLabel.install = function install (Vue) {
  Vue.component(VLabel.name, VLabel)
}

export { VLabel }
export default VLabel
